/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-24 14:25:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-07-12 15:25:29
 * @FilePath: /goldenSalesMobile/src/permission.js
 * @Description:
 */
import router from "./router";
import { getToken, setToken } from "./utils/auth";
import { getBrowserType, setS, getS } from "@/utils/gFunc";
import { getOpenId, getUserInfo } from "@/api/user";
import { silentLogin } from "@/api/user";
import {
  getUrlParam,
  handleSessionStorage,
  handleLocalStorage,
} from "@/utils/index";
import store from "@/store";
import Vue from "vue";

// const whiteList = [
//   'Login',
//   'GoodsDetail',
//   'ShoppingList',
//   'SubmitOrder',
//   'UsersOrder',
//   'ConsumeCode',
//   'ConsumeCodeLink',
//   'Result',
//   'RefundApplication',
//   'RefundOrderList',
//   'RefundOrderDetail',
//   'HomePage',
//   'Order',
// ] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  if (to.meta) {
    if (to.name == "CardRecharge") {
      if (to.query.fromPage === "buy") {
        to.meta.title = "次卡购买";
      } else {
        to.meta.title = "会员卡充值";
      }
    }
    if (to.name == "CustomHomePage") {
      if (to.query.page == 1) {
        to.meta.title = "首页";
      } else if (to.query.page == 2) {
        to.meta.title = "个人中心";
      }
    }
  }

  let browserType = getBrowserType(); // 浏览器环境
  sessionStorage.setItem("phoneSystem", browserType.system);
  store.commit("get_browsertype", JSON.stringify(browserType));
  store.commit("get_browsertype", JSON.stringify(browserType));
  if (browserType.shell === "wechat") {
    // 浏览环境如果是微信内置浏览器，则执行获取用户openId的相关逻辑
    // 判断本地是否已经存储了openId，未存储需要获取微信code，然后向服务端换取openId
    // TODO 更新测试环境需注意
    // let openId = store.state.OpenId;
    let openId = localStorage.getItem("openId");
    let appId = handleLocalStorage.get("appId");
    let componentAppId = handleLocalStorage.get("componentAppId");
    if (process.env.NODE_ENV === "development") {
      // openId = "o-D503R12Qd37HqQ3abJMnwB5A7Q"; //邹 测试 11010803
      // openId = 'oyCkuwByppUwhpQ1JA2Op7dkpqhs';//邹 uat 11010802
      // openId = 'oaw7Z5kGL0tx-iMFroutJPpvwyj0';//邹 水裹 31011001
      // openId = 'oyCkuwEedOiUMgOhHk4ghmTfEaNo';//张波 uat 11010802
      // openId ='oyCkuwByppUwhpQ1JA2Op7dkpqhs'//邹 102103
      //  openId = 'oQnR6wAU-KZ2LBkRgi921s3VatwI';//张波
      // openId = "oahOZ6DsTBnXDykNQzb3FcI3NNYE"; // 张波 水裹测试
     //openId = 'otl0Ow_Nybb_itiw2hUXPJEmOUns';//小白
      
    }
    if (openId === "null" || !openId) {
      console.log("进入授权");
      // snsapi_userinfo:非静默授权，第一次有弹框,snsapi_base:静默授权，没有弹窗
      const code = getUrlParam("code"); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接获取openId
      // const code = this.$route.query.code // 注意：this.$route.query.code是无法获取到code的：http://golden.ticket.goldenyun.cn/?code=061Slqge2CSNNI0Xhsie2nhGge2Slqgk&state=1#/sales/goods-list
      const local = window.location.href;
      if (code == null || code === "") {
        if (!appId) {
          let timeId = setInterval(() => {
            console.log("定时获取appId");
            appId = handleLocalStorage.get("appId");
            componentAppId = handleLocalStorage.get("componentAppId");

            if (appId) {
              clearInterval(timeId);
              handleToAuth();
            }
          }, 500);
        } else {
          handleToAuth();
        }
        function handleToAuth() {
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            appId +
            "&redirect_uri=" +
            encodeURIComponent(local) +
            "&response_type=code&scope=snsapi_base&state=1&component_appid=" +
            componentAppId +
            "#wechat_redirect";
        }
        return;
      } else {
        handleLocalStorage.set("loginCode", code);
        let res = await getOpenId(code); //请求接口换取openId
        if (!res.openid) {
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            appId +
            "&redirect_uri=" +
            encodeURIComponent(local) +
            "&response_type=code&scope=snsapi_base&state=1&component_appid=" +
            componentAppId +
            "#wechat_redirect";

          return;
        }
        openId = res.openid;
      }
    }
    if (!getToken()) {
      await _openIdLogic(openId, to.query);
    } else {
      handleGetVpn(to.query);
    }
  }

  async function _openIdLogic(paramOpenId, pageQuery) {
    // let userInfo = await getUserInfo({ openId: paramOpenId }); // 获取用户是否关注公众号
    store.commit("setStoreVal", { OpenId: paramOpenId });
    localStorage.setItem("openId", paramOpenId);
    // store.commit('setStoreVal', { userInfo });
    await handlerlogin(pageQuery);
  }

  // determine whether the user has logged in 确认用户是否已经登录了
  const hasSaleToken = sessionStorage.getItem("saleToken");
  // const hasToken = '';
  document.title = to.meta.title || "";
  if (hasSaleToken) {
    if (to.path === "/login") {
      // next(`/login?redirect=${to.path}`)
      next("/users/users-order");
    } else {
      try {
        next();
      } catch (error) {
        // remove token and go to login page to re-login 删除token，重新登录
        next(`${to.path}`);
      }
    }
  } else {
    // 如果没有销售员token
    if (to.path === "login") {
      next("/login");
    } else {
      try {
        next();
      } catch (error) {
        // remove token and go to login page to re-login 删除token，重新登录
        next(`${to.path}`);
      }
    }
    /* has no token*/
    // if (whiteList.indexOf(to.name) !== -1) {
    //   // in the free login whitelist, go directly  不需要登录就可以进入的页面

    // } else {
    // other pages that do not have permission to access are redirected to the login page.  没有访问权限的其他页面被重定向到登录页面。
    // next(`/?redirect=${to.path}`);
    // }
  }
});
function handleGetVpn(pageQuery) {
  let getVpnId = store.state.vpnId;
  console.log("permission中vpnId====", getVpnId);
  const preStoreInfo = localStorage.getItem("store");
  if (preStoreInfo) {
    getVpnId = JSON.parse(preStoreInfo).vpnId;
  }
  // if(getVpnId)return;
  $http(`wechath5/zh-cn/v1/vpn`).then((res) => {
    const vpnDatas = res.Items;
    let storeList = vpnDatas.map((v) => {
      const findImg = v.Claims.find((element) => element.TypeId === 1);
      if (findImg) {
        v.storeImg = `${findImg.CdnUrl}/${findImg.Value}`;
      }
      let obj = {};
      obj.text = v.Name;
      obj.value = v.Id;
      obj.code = v.SaaSCode;
      obj.payType = v.SaasVpnSetting.WechatPayChannel;
      obj.SaasVpnSetting = v.SaasVpnSetting;
      obj.Claims = v.Claims;
      return obj;
    });
    const lastStores = localStorage.getItem("allStoreList");
    const nowStores = JSON.stringify(vpnDatas);
    if (!lastStores || nowStores != lastStores) {
      Vue.prototype.resetSetItem("allStoreList", nowStores);
    }
    // 如果页面路径中有vpncode参数，将缓存中门店更新为路径中门店
    if (pageQuery.vpncode) {
      console.log("进度条js中重新设置vpn");
      const vpnItem1 = storeList.find((v) => {
        return v.code === pageQuery.vpncode;
      });
      if (vpnItem1) {
        getVpnId = vpnItem1.value;
      }
    }

    // handleLocalStorage.set('allStoreList',vpnDatas)

    const vpnItem = storeList.find((v) => {
      return v.value === getVpnId;
    });
    console.log(vpnItem);

    if (getVpnId && vpnItem) {
      store.commit("set_vpnid", getVpnId);
      store.commit("set_vpnInfo", {
        name: vpnItem.text,
        code: vpnItem.code,
        payType: vpnItem.payType,
        Claims: vpnItem.Claims,
        ...vpnItem.SaasVpnSetting,
      });
    } else {
      const firstItem = storeList[0];
      store.commit("set_vpnid", firstItem.value);
      store.commit("set_vpnInfo", {
        name: firstItem.text,
        code: firstItem.code,
        payType: firstItem.payType,
        Claims: firstItem.Claims,
        ...firstItem.SaasVpnSetting,
      });
    }
    localStorage.setItem("store", JSON.stringify(store.state));
  });
}

// 静默登录
export function handlerlogin(pageQuery) {
  // const userInfo = store.state.userInfo;
  const params = {
    OpenId: localStorage.getItem("openId"),
    Phone: "",
    // UserName: userInfo.nickname,
    // HeadImageUrl: userInfo.headimgurl,
    LoginMode: "Official",
  };
  return new Promise((resolve, reject) => {
    silentLogin(params).then((res) => {
      if (res.Token) {
        handleSessionStorage.set("wxUserInfo", {
          img: res.HeadImageUrl,
          name: res.UserName,
        });
        setToken(res.Token);
        handleGetVpn(pageQuery);
        if (res.IsDistributor) {
          // 销售员
          localStorage.setItem("userRole", "distributor");
        } else {
          // 消费者
          localStorage.setItem("consumerId", res.UserId);
          localStorage.setItem("userRole", "consumer");
        }

        resolve();
      }
    });
  });
}

// 获取微信code，去服务端换取openId
// async function getCode() {
//   // snsapi_userinfo:非静默授权，第一次有弹框,snsapi_base:静默授权，没有弹窗
//   const code = getUrlParam("code"); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接获取openId
//   // const code = this.$route.query.code // 注意：this.$route.query.code是无法获取到code的：http://golden.ticket.goldenyun.cn/?code=061Slqge2CSNNI0Xhsie2nhGge2Slqgk&state=1#/sales/goods-list
//   const local = window.location.href;
//   if (code == null || code === "") {
//     window.location.href =
//       "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
//       process.env.VUE_APP_APPID +
//       "&redirect_uri=" +
//       encodeURIComponent(local) +
//       "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
//   } else {
//     let res = await getOpenId(code); //请求接口换取openId
//     await _openIdLogic(res.openid);
//   }
// }
